import _classCallCheck from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldInitSpec from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldSet from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet2.js";
import _classPrivateFieldGet from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
var _Spinner;
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { SpinnerComponent } from "./spinner.component.js";
import { SpinnerOverlayComponent } from "./spinner.overlay.component.js";
var _window = /*#__PURE__*/new WeakMap();
var _document = /*#__PURE__*/new WeakMap();
var _spinnerElement = /*#__PURE__*/new WeakMap();
var _mount = /*#__PURE__*/new WeakMap();
var _options = /*#__PURE__*/new WeakMap();
var _create = /*#__PURE__*/new WeakMap();
var _connect = /*#__PURE__*/new WeakMap();
var _register = /*#__PURE__*/new WeakMap();
export var Spinner = /*#__PURE__*/function () {
  function Spinner() {
    var _this = this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Spinner);
    _classPrivateFieldInitSpec(this, _window, window);
    _classPrivateFieldInitSpec(this, _document, _classPrivateFieldGet(_window, this).document);
    _classPrivateFieldInitSpec(this, _spinnerElement, void 0);
    _classPrivateFieldInitSpec(this, _mount, {
      status: false,
      mountTimestamp: 0,
      unmountTimestamp: 0
    });
    _classPrivateFieldInitSpec(this, _options, {
      overlay: true
    });
    _classPrivateFieldInitSpec(this, _create, function () {
      var spinnerElement = new SpinnerComponent();
      if (_classPrivateFieldGet(_options, _this).overlay) {
        var overlayName = _classPrivateFieldGet(_options, _this).overlay;
        var spinnerOverlayElement = new SpinnerOverlayComponent();
        if ({}.toString.call(overlayName) !== "[object String]") {
          overlayName = "default";
        }
        spinnerOverlayElement.setAttribute("class", "spinner-overlay-".concat(overlayName));
        spinnerOverlayElement.appendChild(spinnerElement);
        return spinnerOverlayElement;
      } else {
        return spinnerElement;
      }
    });
    _classPrivateFieldInitSpec(this, _connect, function (spinnerElement) {
      _classPrivateFieldSet(_spinnerElement, _this, spinnerElement);
      return spinnerElement;
    });
    _classPrivateFieldInitSpec(this, _register, function () {
      if (!_classPrivateFieldGet(_window, _this).customElements.get("yy-spinner-component")) {
        _classPrivateFieldGet(_window, _this).customElements.define("yy-spinner-component", SpinnerComponent);
      }
      if (_classPrivateFieldGet(_options, _this).overlay) {
        if (!_classPrivateFieldGet(_window, _this).customElements.get("yy-spinner-overlay-component")) {
          _classPrivateFieldGet(_window, _this).customElements.define("yy-spinner-overlay-component", SpinnerOverlayComponent);
        }
      }
    });
    _classPrivateFieldSet(_options, this, Object.assign(_classPrivateFieldGet(_options, this), Spinner.options, options));
    _classPrivateFieldGet(_register, this).call(this);
    _classPrivateFieldGet(_connect, this).call(this, _classPrivateFieldGet(_create, this).call(this));
    Spinner.instanceAll.push(this);
  }
  return _createClass(Spinner, [{
    key: "mount",
    value: function mount() {
      var _this2 = this;
      var millisecond = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (!_classPrivateFieldGet(_mount, this).status) {
        var mount = function mount() {
          if (!_classPrivateFieldGet(_spinnerElement, _this2).parent()) {
            _classPrivateFieldGet(_document, _this2).body.appendChild(_classPrivateFieldGet(_spinnerElement, _this2));
          }
        };
        _classPrivateFieldGet(_mount, this).status = true;
        clearTimeout(_classPrivateFieldGet(_mount, this).mountTimestamp);
        clearTimeout(_classPrivateFieldGet(_mount, this).unmountTimestamp);
        if (millisecond > 0) {
          _classPrivateFieldGet(_mount, this).mountTimestamp = setTimeout(function () {
            mount();
            clearTimeout(_classPrivateFieldGet(_mount, _this2).mountTimestamp);
          }, millisecond);
        } else {
          mount();
        }
      }
    }
  }, {
    key: "unmount",
    value: function unmount() {
      var _this3 = this;
      var millisecond = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (_classPrivateFieldGet(_mount, this).status) {
        var unmount = function unmount() {
          if (_classPrivateFieldGet(_spinnerElement, _this3).parent()) {
            _classPrivateFieldGet(_spinnerElement, _this3).parent().removeChild(_classPrivateFieldGet(_spinnerElement, _this3));
          }
        };
        _classPrivateFieldGet(_mount, this).status = false;
        clearTimeout(_classPrivateFieldGet(_mount, this).mountTimestamp);
        clearTimeout(_classPrivateFieldGet(_mount, this).unmountTimestamp);
        if (millisecond > 0) {
          _classPrivateFieldGet(_mount, this).unmountTimestamp = setTimeout(function () {
            unmount();
            clearTimeout(_classPrivateFieldGet(_mount, _this3).unmountTimestamp);
          }, millisecond);
        } else {
          unmount();
        }
      }
    }
  }, {
    key: "isMount",
    value: function isMount() {
      return _classPrivateFieldGet(_mount, this).status;
    }
  }, {
    key: "isMountDocument",
    value: function isMountDocument() {
      return !!_classPrivateFieldGet(_spinnerElement, this).parent();
    }
  }]);
}();
_Spinner = Spinner;
_defineProperty(Spinner, "options", {
  overlay: true
});
_defineProperty(Spinner, "clear", function () {
  var instanceAll = _Spinner.instanceAll;
  while (instanceAll.length > 0) {
    instanceAll[0].unmount();
    instanceAll.splice(0, 1);
  }
});
_defineProperty(Spinner, "instanceAll", []);